module.exports = __webpack_public_path__ + "img/concord_cover.3ab4c9a6.webp";